export default "__VITE_ASSET__o2L5XvgQ__"